<template>
    <Home fit="cover">
        <template #picture>
            <!-- background -->
            <source media="(orientation: portrait)" srcset="../assets/img/titelbild_rueckbau.png">
            <source media="(orientation: landscape)" srcset="../assets/img/titelbild_rueckbau.png">
        </template>
        <template #headline>Lernt alle 16 Bundesländer kennen!</template>
        <template #subline></template>     
         <!--&#x1F50D;--> 
         <!--<span style="font-size:75%">-->
        <template #text>
        </template>
        <template #update>
            <font color =#d0455b>August 2025<br></font>
            
        </template>
    </Home>
</template>

<script>
    export default {
        name: 'home',
        babylonState: {
            camera: {
                position: [-1.57, 0.1, 60],
                target: [0,0,1],
                radiusLimits:[3,60],
                stopOnClick: false,
            },
            zdfLogo: false
        },
        babylonReady: function ()
        {

        },
        // methods: {
        //     next: function () {
        //         this.$tracking.navigationClick('Start');
        //         this.$eventBus.$emit('nextPage');
        //     }
        // },
    }
</script>

<style lang="scss">

    .home {

        // change default opacity: 0.35
        .home__background {

            opacity: 1;
        }
        // change default object-position: unset (50% 50%)  / Für Portrait ist nur der x-Wert relevant, für Landscape nur der y-Wert. / Einheit entweder in "%" oder "px"
        .home__background img.o-fit {

            //object-position: 50% 0%;
            //
            //@media (orientation: landscape) {
            //
            //    object-position: 0% 50%;
            //}
        }
    }

</style>
